import { useI18n } from "@baton/i18n";
import { Dialog } from "@baton/ui";
import { useUiStore } from "../../app/uiStore.ts";
import { DialogFormSkeleton } from "../../skeletons/Skeletons.tsx";

/**
 * A dialog the shell opens from anywhere while its code, or a Clients dialog's area words, load
 * (FR-015-090): the real frame with its title at once and the form's fields as bars. The frame is
 * modal from the click on, so nothing behind it can be opened in the wait and then be covered when
 * the dialog arrives. With no frame until then (the Clients dialogs from 2026-09-27, the move, close
 * reason and Remind dialogs since), a menu opened in that wait stayed open under the arriving dialog,
 * hidden from assistive technology and holding a focus trap of its own (2026-10-05).
 */
export function DialogLoading({ title, description, size, fields, editor = false, onClose }: { readonly title: string; readonly description?: string; readonly size: "sm" | "md" | "lg"; readonly fields: number; readonly editor?: boolean; readonly onClose: () => void }) {
  return (
    <Dialog open onOpenChange={(open) => { if (!open) onClose(); }} title={title} {...(description === undefined ? {} : { description })} size={size}>
      <DialogFormSkeleton fields={fields} editor={editor} />
    </Dialog>
  );
}

/** Log a call or meeting while it loads, titled for what it was opened to do: log one, edit an entry or read one. */
export function LogInteractionLoading() {
  const { t } = useI18n();
  const state = useUiStore((store) => store.logInteraction);
  const setLogInteraction = useUiStore((store) => store.setLogInteraction);
  const title = state.mode === "new" ? t("shell.create.call") : state.mode === "edit" ? t("shell.logEntry.edit") : t("shell.logEntry.read", { kind: state.entry?.kind ?? "call" });
  return <DialogLoading title={title} size="md" fields={3} onClose={() => { setLogInteraction({ open: false }); }} />;
}
